<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field    
        readonly
        v-on="on"      
        :value="setectVale"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"        
      @change="save"
    ></v-date-picker>
  </v-menu>
</template>

<script>
  export default {
      props: ["setectVale"],
    data: () => ({  
      menu: false,
    }),
    watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'Date'))
      },
    },
    methods: {
      save (date) {      
        this.$emit("changeInput", date);    
        this.menu = false
      }      
    },
  }
</script>